document.addEventListener("DOMContentLoaded", function () {
  // Ensure customerId is available before making the request
  if (!customerId) {
    console.error("Customer ID is not available.");
    return;
  }

  // Fetch activity logs from Firestore
  fetch(`https://us-central1-la-roue-53165.cloudfunctions.net/getCustomerActivityLogs?customerId=${customerId}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to fetch activity logs");
      }
      return response.json();
    })
    .then((data) => {
      if (data.success) {
        const activityLogs = data.activityLogs;
        console.log('Received activity logs:', activityLogs); // For debugging
        populateActivityLogsTable(activityLogs);
      } else {
        console.error("Failed to fetch activity logs: ", data.message);
      }
    })
    .catch((error) => {
      console.error("Error fetching activity logs: ", error);
    });
});

function populateActivityLogsTable(activityLogs) {
  const tableBody = document.querySelector("#rewards-history-table tbody");
  tableBody.innerHTML = ""; // Clear any existing rows

  if (activityLogs.length === 0) {
    const emptyRow = document.createElement("tr");
    const emptyCell = document.createElement("td");
    emptyCell.colSpan = 4;
    emptyCell.textContent = "Brak historii nagród.";
    emptyRow.appendChild(emptyCell);
    tableBody.appendChild(emptyRow);
    return;
  }

  activityLogs.forEach((log) => {
    console.log('Processing log:', log); // For debugging

    const row = document.createElement("tr");

    // Date
    const dateCell = document.createElement("td");
    const date = new Date(log.timestamp);
    dateCell.textContent = date.toLocaleDateString("pl-PL", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
    row.appendChild(dateCell);

    // Activity Description
    const actionCell = document.createElement("td");
    actionCell.textContent = translateActivityDescription(log.description, log.activityType);
    row.appendChild(actionCell);

    // Points Added
    const pointsCell = document.createElement("td");
    pointsCell.textContent = log.pointsAdded;
    row.appendChild(pointsCell);

    // Status
    const statusCell = document.createElement("td");

    // Define the activity types that are pending
    const pendingActivityTypes = ["order_created", "review_submitted"];
    const isPending = pendingActivityTypes.includes(log.activityType);

    statusCell.textContent = isPending ? "Oczekujące" : "Zakończone";
    row.appendChild(statusCell);

    tableBody.appendChild(row);
  });
}

function translateActivityDescription(description, activityType) {
  const translationsByActivityType = {
    "instagram_follow": "Zaobserwowanie nas na Instagramie",
    "order_created": "Punkty za złożenie zamówienia",
    "birthday_reward": "Dodanie daty urodzin",
    "review_submitted": "Przesłanie recenzji produktu",
    "milestone_reward": "Osiągnięto kamień milowy. Zdobyto dodatkowe punkty",
    // Add other activity types and their translations as needed
  };

  // Use activityType for translation if available
  if (activityType && translationsByActivityType[activityType]) {
    return translationsByActivityType[activityType];
  }

  // Fallback to existing translations based on description
  const translations = {
    "Instagram post completion reward points added": "Udostępnienie posta na Instagramie",
    "Instagram story completion reward points added": "Udostępnienie relacji na Instagramie",
    "Google review reward points": "Dodanie opinii w Google",
    "Initial signup reward points": "Założenie konta",
    "Review review_margo reward points added": "Dodanie recenzji spodni Margo"
  };

  // Handle dynamic descriptions if needed
  if (description.startsWith("Order placed. Earned")) {
    return "Punkty za złożenie zamówienia";
  }
  if (description.startsWith("Milestone reached. Earned bonus points")) {
    return "Osiągnięto kamień milowy. Zdobyto dodatkowe punkty";
  }
  if (description.startsWith("Followed brand on Instagram and earned")) {
    return "Zaobserwowanie nas na Instagramie";
  }
  // Add other dynamic cases as needed...

  return translations[description] || description;
}
